export enum LicenseDialogMessagesEnum {
    LicenseActivatedSuccess = 'The license was successfully activated',
    LicenseActivatedFailed = 'Invalid license file',

    InvalidLicenseKey = 'Invalid license key!',

    ConnectionToRemoteServerFailed = 'Can not connect to remote server.',
    ConnectionToServerFailed = 'Please generate a license request and send it to our licensing department',
    ConnectionToServerFailedTitle = 'We couldn’t reach our server for license validation.',

    FileUploadedSuccess = 'File was successfully uploaded.',
    FileUploadedFailed = 'The license can not be activated by the current license file.',
    FileGeneratedSuccess = 'File was successfully generated.',

    LicenseRequestTitle = 'License request',

    LicenseGuargTitle = 'Permission denied',
    LicenseGuargMainMessage = 'You can not go to the other pages until you activate a license',

    WrongFileTypeSelectedTitle = 'Wrong file type',
    WrongFileTypeSelectedError = 'You can upload only \'.lic\' or \'.olic\' files',
    WrongFileTypeTxtSelectedError = 'You can upload only \'.lic\' or \'.olic\' files',

    CloseModalWindow = 'License activation is in progress. If you close the window the progress will be stopped.',

    WrongFileTypeUploadingTitle = 'Wrong file type',
    WrongFileTypeUploadingDescription = 'You can upload only \'zip\' files',

    OSBASEFileDownloadededSuccess = 'OSBASE device list was generated successfully and saved in your default Downloads folder.',
    OSBASELicensesWereAppliedSuccessfully = 'OSBASE license key(s) applied successfully',
    OSBASEDriverIsNotRunningOnTheSelectedLocation = 'OSBASE driver is not running on the selected location',
    RunsAsAdministratorTitle = 'To run the OSBASE features, MAWI Agent must run as Administrator. Please connect to the MAWI Agent system and accept elevation of the MAWI Agent application. Restart the Agent as Administrator?',

    PasswordExpiredTitle = 'Password expired',
    PasswordExpiredMessage = 'Please click here to change your password',

    ManageLaunchersPermissionDeniedTitle = 'Manage launchers is not available for current license'
}
